<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5571_92955)">
      <path
        d="M3.26604 7.91985C3.36034 7.62149 3.25573 7.29586 3.0045 7.10799C2.33922 6.61145 1.02856 5.63235 0.148155 4.97521C0.0206993 4.88017 -0.0308723 4.71441 0.0184893 4.56338C0.0685877 4.41309 0.210042 4.31143 0.368441 4.31143H3.7825C4.10003 4.31143 4.38147 4.10809 4.48166 3.80604C4.75057 2.99344 5.28545 1.37783 5.64056 0.307381C5.68992 0.157091 5.83064 0.0554242 5.98903 0.0546875C6.14817 0.0546875 6.28889 0.156354 6.33899 0.306644C6.69778 1.37783 7.23928 2.99565 7.51041 3.80825C7.61134 4.10883 7.89277 4.31143 8.20957 4.31143C9.01704 4.31143 10.5723 4.31143 11.6317 4.31143C11.7901 4.31143 11.9309 4.41235 11.9809 4.56264C12.031 4.71293 11.9802 4.8787 11.8535 4.97373C10.9753 5.6353 9.6639 6.62324 9.0001 7.12273C8.75034 7.31059 8.64646 7.63548 8.7415 7.93385C8.99789 8.74424 9.51213 10.3687 9.85987 11.4657C9.9085 11.6196 9.85177 11.7869 9.71989 11.879C9.58802 11.971 9.41193 11.9674 9.28448 11.8694C8.40186 11.1923 7.1133 10.2029 6.43845 9.68502C6.17322 9.48169 5.80411 9.48242 5.53889 9.68649C4.87066 10.2037 3.59979 11.1864 2.72454 11.8628C2.59708 11.9615 2.421 11.9659 2.28839 11.8738C2.15651 11.781 2.09978 11.6137 2.14841 11.4605C2.49541 10.3599 3.00966 8.73245 3.26604 7.91985Z"
        fill="#FF9E48"
      />
    </g>
    <defs>
      <clipPath id="clip0_5571_92955">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
